// The public roadmap — CURATED themes, founder-blessed. Direction, not detail.
// Edit freely; one line each; move items between columns as reality moves.

export interface RoadmapItem {
  title: string
  note: string
}

export const ROADMAP: { column: 'now' | 'next' | 'later'; label: string; items: RoadmapItem[] }[] = [
  {
    column: 'now',
    label: 'Now',
    items: [
      { title: 'Federal contracting, end to end', note: 'Live lake, fit briefs read from real solicitation documents, recompete radar.' },
      { title: 'Tala acts', note: 'Tool-bearing mission steps behind human gates: cited artifacts, backtested rule proposals.' },
      { title: 'Media domains', note: 'Your library as a domain: anime, manga, and what feeds them.' },
    ],
  },
  {
    column: 'next',
    label: 'Next',
    items: [
      { title: 'Any agent, via a protocol', note: 'Scoped access for outside agents: read and propose, never judge.' },
      { title: 'Headed browser sources', note: 'Pipelines for the pages plain fetchers can’t reach.' },
      { title: 'Credentialed springs', note: 'Paid and logged-in sources with budgets that stop before the wall.' },
    ],
  },
  {
    column: 'later',
    label: 'Later',
    items: [
      { title: 'Domains as an ecosystem', note: 'Rule packs and templates per operator archetype.' },
      { title: 'The desktop verse', note: 'Diwa beyond the browser.' },
    ],
  },
]
